import { definirCorte } from "@/utils/eventosDoFunil";

// A chave do corte da medição vale para a página toda: os componentes só perguntam ao util.
export default defineNuxtPlugin(() => {
  const ligado = useRuntimeConfig().public.medicaoCorte;
  definirCorte(ligado === true || ligado === "true");
});
